import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { generateInitials, getColorFromString } from '../../utils/initials.util';

import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, TranslateModule],
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
})
export class UserAvatarComponent implements OnChanges {
  @Input() photoPath: string | SafeUrl | null | undefined;
  @Input() userName: string | null | undefined;
  @Input() size: 'xs' | 'small' | 'medium' | 'large' | 'header' | 'menu' = 'medium';
  @Input() editable: boolean = false;

  imageError = false;

  /**
   * Reset imageError quando o photoPath muda
   * (caso contrário, se a foto falhar uma vez, nunca mais volta a tentar)
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['photoPath']) {
      this.imageError = false;
    }
  }

  /**
   * Handle image load error
   * Sets flag to show initials fallback
   */
  onImageError(): void {
    this.imageError = true;
  }

  /**
   * Get user initials for fallback display
   */
  get initials(): string {
    return generateInitials(this.userName);
  }

  /**
   * Get consistent background color based on userName
   */
  get backgroundColor(): string {
    return getColorFromString(this.userName);
  }

  /**
   * Get CSS class for avatar size
   */
  get sizeClass(): string {
    return `avatar-${this.size}`;
  }
}
